import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment, { Moment } from 'moment';
import { map, Observable } from 'rxjs';
import { Gym, GymType } from 'src/app/model/gym';
import { AttributeChangeSchedule } from 'src/app/model/schedule/attribute-change-schedule';
import { SelectOption } from 'src/app/model/select-option';
import { GymFinderService } from 'src/app/service/gymfinder.service';
import { NetworkService } from 'src/app/service/network.service';
import { MembershipTypeScheduleUtils } from 'src/app/util/membership-type-schedule-util';
import { SelectUtils } from 'src/app/util/select-util';

export type AddItemDialogData = {
  schedule: AttributeChangeSchedule;
  gym?: Gym;
};

export const DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'gymfinder-add-attribute-change-schedule-dialog',
  templateUrl: './add-attribute-change-schedule-dialog.component.html',
  styleUrls: ['./add-attribute-change-schedule-dialog.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS }],
  standalone: false,
})
export class AddAttributeChangeScheduleDialogComponent implements OnInit {
  schedule: AttributeChangeSchedule;

  optionsValues: Observable<SelectOption[]>;

  scheduledAt?: Moment;

  minDate: Date;

  constructor(
    private dialogRef: MatDialogRef<AddAttributeChangeScheduleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: AddItemDialogData,
    private gymFinderService: GymFinderService,
    private networkService: NetworkService
  ) {
    this.schedule = { ...data.schedule };
  }
  ngOnInit(): void {
    const currentDate = new Date();
    this.minDate = new Date(
      Date.UTC(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + 1
      )
    );
    this.scheduledAt = moment(this.minDate);
    this.schedule.scheduledAt = this.minDate.toISOString();
    this.networkService.network$.subscribe(network => {
      this.optionsValues = this.gymFinderService.getOptions(network).pipe(
        map(to => {
          return SelectUtils.valuesFromGymTypesOptions(to.gymTypes);
        })
      );
    });
  }

  public add() {
    this.dialogRef.close(this.schedule);
  }

  public closeDialog() {
    this.dialogRef.close(undefined);
  }

  public get isFrBeMembershipTypeOption(): boolean {
    return (
      MembershipTypeScheduleUtils.isAvailableFor(this.data.gym) &&
      (this.schedule.name === GymType.WELLPASS_FR_BE_CREDITS ||
        this.schedule.name === GymType.WELLPASS_FR_BE_UNLIMITED)
    );
  }

  public get value(): boolean {
    return this.schedule.value === 'true';
  }

  public set value(value: boolean) {
    this.schedule.value = '' + value;
  }

  public get scheduled(): Moment | undefined {
    return this.scheduledAt;
  }

  public set scheduled(value: Moment | undefined) {
    this.scheduledAt = value;
    if (value) {
      const scheduledAt = value.toDate();
      this.schedule.scheduledAt = scheduledAt.toISOString();
    } else {
      this.schedule.scheduledAt = undefined;
    }
  }
}
